import React from 'react';
import { capitaliseFirst } from './stringUtils';

export interface Group {
  id: string;
  title: string;
  root: boolean;
}

export interface OpenGroups {
  [key: number]: boolean;
}

/**
 * generate nested tree view
 * @param group - group object
 * @param openGroups - open group states
 * @param hasChildren - whether the group has children
 * @param howManyChildren - number of children text
 * @param onToggleGroup - toggle group state callback
 * @returns React node
 */
export const generateNestedTreeView = (
  group: Group,
  openGroups: OpenGroups,
  hasChildren: boolean,
  howManyChildren: string = '',
  onToggleGroup: (id: number) => void,
): React.ReactElement => {
  const howManyChildrenText = howManyChildren ? `: ${howManyChildren}` : '';
  if (group.root && hasChildren) {
    return (
      <div
        onClick={() => onToggleGroup(parseInt(group.id))}
        style={{ cursor: 'pointer' }}
        className={
          openGroups[parseInt(group.id)]
            ? 'labelSimple expanded'
            : 'labelSimple'
        }
      >
        <span className="arrowCollapse" style={{ marginRight: 10 }}>
          <i
            className={`fa-solid fa-chevron-${
              openGroups[parseInt(group.id)] ? 'up' : 'down'
            } fa-lg`}
          ></i>
        </span>
        {capitaliseFirst(group.title) + howManyChildrenText}
      </div>
    );
  } else if (!group.root && hasChildren) {
    return (
      <div
        onClick={() => onToggleGroup(parseInt(group.id))}
        style={{ cursor: 'pointer', paddingLeft: 26 }}
        className={
          openGroups[parseInt(group.id)]
            ? 'labelSimple expanded '
            : 'labelSimple'
        }
      >
        <span className="arrowCollapse" style={{ marginRight: 10 }}>
          <i
            className={`fa-solid fa-chevron-${
              openGroups[parseInt(group.id)] ? 'up' : 'down'
            } fa-lg`}
          ></i>
        </span>
        {capitaliseFirst(group.title) + howManyChildrenText}
      </div>
    );
  } else if (group.root && !hasChildren) {
    return (
      <div className="labelSimple" style={{ paddingLeft: 26 }}>
        {capitaliseFirst(group.title)}
      </div>
    );
  } else {
    return (
      <div
        className="labelGrey"
        style={{
          paddingLeft: 54,
          fontSize: 12,
          height: 40,
          overflow: 'hidden',
        }}
      >
        {capitaliseFirst(group.title)}
      </div>
    );
  }
};
